"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const javascript_time_ago_1 = __importDefault(require("javascript-time-ago"));
const getTimeString_1 = require("../../utils/getTimeString");
const Component_1 = __importDefault(require("../Component"));
const heart_sprite_svg_1 = __importDefault(require("../../resources/svg/heart.sprite.svg"));
const renderSvgSprite_1 = require("../../render/renderSvgSprite");
const isTrackLiked_1 = require("../../utils/tracks/isTrackLiked");
class TrackComponent extends Component_1.default {
    constructor(trackData) {
        super();
        this.trackData = trackData;
        this.createdAt = new Date(trackData.createdAt);
        this.liked = (0, isTrackLiked_1.isTrackLiked)(trackData);
    }
    addOnLikeListener(callback) {
        const likeButton = this.getElement().querySelector('.track__like-btn');
        if (!(likeButton instanceof HTMLButtonElement)) {
            throw new TypeError('track__like-btn is not button');
        }
        likeButton.addEventListener('click', callback);
    }
    addOnDropdownListener(callback) {
        const dropdownButton = this.getElement().querySelector('.track__btn-dropdown');
        if (!(dropdownButton instanceof HTMLButtonElement)) {
            throw new TypeError('track__btn-dropdown is not button');
        }
        dropdownButton.addEventListener('click', callback);
    }
    addOnClickListener(callback) {
        const link = this.getElement().querySelector('.track__name__link');
        if (!link) {
            throw new Error('.track__name__link not found');
        }
        link.addEventListener('click', (event) => {
            event.preventDefault();
            callback();
        });
    }
    getTemplate() {
        const timeAgo = new javascript_time_ago_1.default('ru-RU');
        return `
      <li class="tracks__item flex" id="track-item-${this.trackData.id}">
        <div class="tracks__item__number">${this.trackData.index + 1}</div>
        <div class="tracks__item__name"><img class="track__img" src="${this.trackData.image}" alt="${this.trackData.album.name}">
          <div class="track__content">
            <h3 class="track__name"><a class="track__name__link" href="#">${this.trackData.name}</a></h3><span class="track__author">${this.trackData.artist.name}</span>
          </div>
        </div>
        <div class="tracks__item__albom">${this.trackData.album.name}</div>
        <div class="tracks__item__data flex"><span class="data__text">${timeAgo.format(this.createdAt)}</span>
          <button class="track__like-btn ${this.liked ? 'like-btn--active' : ''}">

          ${(0, renderSvgSprite_1.renderSvgSprite)(heart_sprite_svg_1.default.url, 'track__like-icon')}

          </button>
        </div>
        <time class="tracks__item__time">${(0, getTimeString_1.getTimeString)(this.trackData.duration)}</time>
        <div class="tracks__item__drop">
          <button class="track__btn-dropdown"><svg width="23" height="4" viewBox="0 0 23 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="2" r="2" fill="#C4C4C4"/>
      <circle cx="11.5" cy="2" r="2" fill="#C4C4C4"/>
      <circle cx="21" cy="2" r="2" fill="#C4C4C4"/>
      </svg>
          </button>
        </div>
      </li>
    `;
    }
}
exports.default = TrackComponent;
